import type { QuickFilter, WeekendEvent } from '../types/content'

/** Which mocked route each hub points at in this prototype. */
export const hubRoutes: Record<string, string> = {
  'Family events': '/events',
  'Things to do': '/things-to-do',
  'Parks & playgrounds': '/parks',
  'Classes & sports': '/classes',
  'Parent resources': '/for-parents',
}

export const quickFilters: QuickFilter[] = [
  { id: 'free', label: 'Free', hint: '' },
  { id: 'toddler', label: 'Toddler-friendly', hint: '' },
  { id: 'shade', label: 'Shady', hint: '' },
  { id: 'indoor', label: 'Indoor', hint: '' },
  { id: 'weekend', label: 'This weekend', hint: '' },
  { id: 'birthday', label: 'Birthday parties', hint: '' },
]

/**
 * The seven hubs after consolidation — down from the ten category pages
 * that exist on the live site today.
 */
export interface Hub {
  title: string
  path: string
  blurb: string
  count: string
}

export const hubs: Hub[] = [
  {
    title: 'Family events',
    path: '/family-events-santa-barbara',
    blurb: 'Storytimes, concerts, festivals — submitted by locals, checked weekly.',
    count: '38 this month',
  },
  {
    title: 'Things to do',
    path: '/family-activities-in-santa-barbara',
    blurb: 'Attractions, beaches, libraries, rainy days and free afternoons.',
    count: '96 places',
  },
  {
    title: 'Parks & playgrounds',
    path: '/santa-barbara-parks-playgrounds-kids',
    blurb: 'Shade, restrooms, fencing, parking — the things that decide a morning.',
    count: '41 parks',
  },
  {
    title: 'Classes & sports',
    path: '/kids-classes-sports-santa-barbara',
    blurb: 'Swim, dance, gymnastics, soccer and music, with sign-up windows.',
    count: '63 programs',
  },
  {
    title: 'Preschools & childcare',
    path: '/preschools-daycares-santa-barbara',
    blurb: 'Every program in the county, with waitlist timing that actually helps.',
    count: '48 schools',
  },
  {
    title: 'Parent resources',
    path: '/parenting-resources-santa-barbara',
    blurb: 'Mom groups, postpartum support, therapists, gyms with childcare.',
    count: '54 providers',
  },
  {
    title: 'Shops & eats',
    path: '/kids-shopping-santa-barbara',
    blurb: 'Toy stores, kids clothes and restaurants that welcome a toddler.',
    count: '33 spots',
  },
]

export const weekendEvents: WeekendEvent[] = [
  {
    id: 'e1',
    day: 'Fri',
    date: 'Jun 12',
    name: 'Toddler storytime on the lawn',
    place: 'Central Library, Downtown',
    time: '10:30am',
    cost: 'Free',
    ages: '0–4',
  },
  {
    id: 'e2',
    day: 'Fri',
    date: 'Jun 12',
    name: 'Twilight tidepool walk',
    place: 'Sea Center, Stearns Wharf',
    time: '5:30pm',
    cost: '$',
    ages: '4+',
  },
  {
    id: 'e3',
    day: 'Sat',
    date: 'Jun 13',
    name: 'Farmers market scavenger hunt',
    place: 'SB Public Market',
    time: '9:00am',
    cost: 'Free',
    ages: '3–9',
  },
  {
    id: 'e4',
    day: 'Sat',
    date: 'Jun 13',
    name: 'Concerts in the park: kids’ set',
    place: 'Chase Palm Park',
    time: '4:00pm',
    cost: 'Free',
    ages: 'All',
  },
  {
    id: 'e5',
    day: 'Sun',
    date: 'Jun 14',
    name: 'Carousel morning & playground meetup',
    place: 'Chase Palm Park',
    time: '9:30am',
    cost: '$',
    ages: '0–6',
  },
]
